import { config } from "../../utils/config/config";

const API_URL = `${config.BASE_URL}${config.API_PATH}`;
type MandatoryHeaders = {
  "Access-Control-Allow-Origin": string;
  Authorization: string;
  "Content-Type": string;
};

const mandatoryHeadersCoworkerCompanionAPIBuilder = (
  token: string
): MandatoryHeaders => {
  return {
    "Access-Control-Allow-Origin": '*',
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};


const genericCoworkerCompanionAPICall = async (
  token: string,
  method: string,
  endpoint: string,
  BODY: string
): Promise<Response> => {
  
  const headers = mandatoryHeadersCoworkerCompanionAPIBuilder(token);

  const requestOptions: RequestInit = {
    method: `${method}`,
    body: BODY === "" ? undefined : BODY,
    headers: headers,
    redirect: "follow",
  };
  const url = API_URL + "/" + endpoint;

  return fetch(url, requestOptions)

  // return data;
  // });
  // .catch((error) => {
  //   //TODO : error log
  //   return error;
  // });
};

const testApiCall = async (
  token: string
): Promise<Response> => {
  
  const headers = mandatoryHeadersCoworkerCompanionAPIBuilder(token);

  const requestOptions: RequestInit = {
    method: `GET`,
    headers: headers,
    redirect: "follow",
  };

  return fetch(config.BASE_URL, requestOptions)

  // return data;
  // });
  // .catch((error) => {
  //   //TODO : error log
  //   return error;
  // });
};
export { genericCoworkerCompanionAPICall, testApiCall };
